// extracted by mini-css-extract-plugin
module.exports = {"div_box":"CciGpt_div_box__2hbmQ","tableRow":"CciGpt_tableRow__27N4t","answer_ellipsis":"CciGpt_answer_ellipsis__24G15"};